
<template>
  <div class="GolfMemberShip">
    <div class="homepage">
      <h2 class="Orangetitle">RacePark Experiences</h2>

      <!-- Package cards -->
      <b-row class="membership-Options container above1400">
        <b-col
          lg="6"
          sm="12"
          v-for="(racePack, index) in acf.acf && acf.acf.packages
            ? acf.acf.packages
            : []"
          :key="index"
          class="packageSections"
        >
          <div class="borderMemberShip">
            <img
              class="raceparkImage"
              :src="racePack.image"
              :alt="racePack.title"
            >

            <h2 class="blacktitle">{{ racePack.title }}</h2>

            <p
              class="descript"
              v-html="racePack.description"
            ></p>

            <!-- Enquiry and Championship Schedule buttons -->
            <div class="memberEnquiry">
              <b-link :to="'/contact'">
                <b-button class="MemberBtn">
                  Get in Touch Today
                </b-button>
              </b-link>

              <b-button
                v-if="racePack.pop_up_image"
                class="ScheduleBtn"
                @click="openSchedule(racePack)"
              >
                Championship Schedule
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Championship Schedule popup -->
    <b-modal
      v-model="showSchedule"
      centered
      size="lg"
      hide-footer
      title="Championship Schedule"
      modal-class="racepark-schedule-modal"
      body-class="racepark-schedule-body"
      header-bg-variant="dark"
      header-text-variant="white"
      backdrop-variant="dark"
    >
      <div
        v-if="selectedPackage && selectedPackage.pop_up_image"
        class="schedule-image-container"
      >
        <img
          :src="selectedPackage.pop_up_image"
          :alt="selectedPackage.title + ' Championship Schedule'"
          class="schedule-image"
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Packages',

  components: {},

  data: function () {
    return {
      acf: [],
      showSchedule: false,
      selectedPackage: null,
    }
  },

  methods: {
    isMobile() {
      return screen.width <= 500
    },

    openSchedule(racePack) {
      this.selectedPackage = racePack
      this.showSchedule = true
    },
  },

  mounted() {
    axios
      .get(
        process.env.VUE_APP_API_URL +
          'racepark' +
          '/wp-json/wp/v2/pages/4' +
          '?randomadd=' +
          new Date().getTime()
      )
      .then((response) => {
        this.acf = response.data
      })
      .catch((error) => {
        console.error('Error loading RacePark packages:', error)
      })
  },
}
</script>

<style scoped>
.packageSections {
  margin-bottom: 60px;
}

img.raceparkImage {
  width: 100%;
}

p.descript {
  font-size: 18px;
  color: #11182F;
  font-family: "noto-sans", sans-serif;
  font-weight: 400;
  font-style: normal;
  text-align: left;
  padding-top: 20px;
}

.bannersec {
  display: block;
  margin: auto;
  padding-bottom: 60px;
}

.banner {
  width: 100%;
}

ul.MemberBullet-Points.pMonth {
  margin-top: 93px;
}

img.ImageLogo.Car {
  width: 120px;
  height: auto;
  margin-top: 41px;
}

img.ImageLogo.member {
  height: 50px;
  position: relative;
  top: 20px;
  margin-bottom: 20px;
}

span.sideText {
  font-size: 32px;
  display: block;
}

/* Get in Touch button */
button.MemberBtn {
  background-color: #D80E1F;
  border-color: #D80E1F !important;
  border-radius: 50px;
  width: 252px;
  height: 54px;
  line-height: 1;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  font-family: "noto-sans", sans-serif;
}

button.MemberBtn:hover {
  background-color: #707070;
  border-color: #707070 !important;
  color: #fff;
}

/* Championship Schedule button */
button.ScheduleBtn {
  background-color: #11182F;
  border-color: #11182F !important;
  border-radius: 50px;
  min-height: 54px;
  padding: 10px 22px;
  line-height: 1.2;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  font-family: "noto-sans", sans-serif;
  white-space: nowrap;
}

button.ScheduleBtn:hover {
  background-color: #707070;
  border-color: #707070 !important;
  color: #fff;
}

/* Keep both buttons alongside each other */
.memberEnquiry {
  position: absolute;
  bottom: -35px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  z-index: 1;
}

.Orangetitle {
  color: #D80E1F;
  font-size: 40px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
  font-style: italic;
}

.blacktitle {
  color: #11182F;
  font-size: 28px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
  font-style: italic;
  text-align: left;
  height: 50px;
  padding-top: 20px;
  margin-top: 20px;
}

.GolfMemberShip {
  padding: 50px;
  padding-bottom: 100px;
}

.blackStandard-text {
  font-size: 24px;
  color: #11182F;
  font-family: "noto-sans", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.golfParkText-width {
  width: 70%;
  text-align: center;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 30px;
}

button.golfMemberBtn {
  background-color: #1A1A1A;
  border-color: #1A1A1A !important;
  border-radius: 50px;
  width: 535px;
  height: 54px;
  line-height: 1;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  margin-top: 25px;
  margin-bottom: 50px;
  font-family: "noto-sans", sans-serif;
}

button.golfMemberBtn:hover {
  background-color: #707070;
  border-color: #707070 !important;
  color: #fff;
}

.membership-Options {
  margin-top: 60px;
  margin: auto;
}

h3.Membership-Prices {
  color: #D80E1F;
  font-size: 29px;
  padding-top: 5px;
  font-family: "noto-sans", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.perMonth {
  color: #D80E1F;
  font-size: 15px;
  font-weight: bold;
}

.borderMemberShip {
  padding-top: 40px;
  padding-bottom: 40px;
}

ul.MemberBullet-Points {
  color: #11182F;
  font-size: 22px;
  text-align: left;
  list-style-type: circle;
  margin-top: 50px;
  font-family: "noto-sans", sans-serif;
  font-weight: 400;
  font-style: normal;
  padding-right: 50px;
  padding-left: 58px;
}

ul.MemberBullet-Points > li {
  padding-bottom: 10px;
}

/* Championship Schedule image */
.schedule-image-container {
  width: 100%;
  text-align: center;
}

.schedule-image {
  display: block;
  width: 100%;
  height: auto;
  max-height: 75vh;
  object-fit: contain;
}

/* Modal styling */
::v-deep .racepark-schedule-modal .modal-content {
  border: none;
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: auto;
    pointer-events: auto;
    background-color: #fff;
    /* background-clip: padding-box; */
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: .3rem;
    outline: 0;
    margin: auto;
}
::v-deep .racepark-schedule-modal .modal-header {
  background-color: #11182F !important;
  color: #fff;
  border-bottom: none;
}

::v-deep .racepark-schedule-modal .modal-title {
  font-family: "korolev", sans-serif;
  font-weight: 700;
  font-style: italic;
}

::v-deep .racepark-schedule-modal .close {
  color: #fff;
  text-shadow: none;
  opacity: 1;
}

::v-deep .racepark-schedule-body {
  padding: 20px;
}

/* Mobile CSS */
@media only screen and (min-width: 1401px) {
  .below1400 {
    display: none;
  }
}

@media only screen and (max-width: 1400px) {
  .PayandPlay {
    height: 600px;
  }

  .blacktitle {
    color: #11182F;
    font-size: 32px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
    padding-left: 20px;
    padding-right: 20px;
  }

  .PandP {
    margin-bottom: 30px;
  }
}

@media only screen and (min-width: 1200px) {
  ul.MemberBullet-Points.MBP-desktop {
    margin-top: 53px;
  }
}

@media only screen and (max-width: 1024px) {
  .PayandPlay {
    height: 540px !important;
  }
}

@media only screen and (max-width: 990px) {
  .borderMemberShip {
    height: 1100px;
    margin-bottom: 20px;
  }

  .memberEnquiry {
    position: absolute;
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    bottom: 0;
    gap: 10px;
  }

  button.MemberBtn {
    width: auto;
    padding: 10px 18px;
  }

  button.ScheduleBtn {
    padding: 10px 18px;
  }
}

@media only screen and (max-width: 768px) {
  .blacktitle {
    color: #11182F;
    font-size: 32px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
    padding-left: 0;
    padding-right: 20px;
    height: auto;
  }

  img.raceparkImage {
    width: 100%;
    margin-top: 0;
  }

  button.MemberBtn {
    background-color: #D80E1F;
    border-color: #D80E1F !important;
    border-radius: 50px;
    height: 54px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: auto;
    font-family: "noto-sans", sans-serif;
  }

  button.MemberBtn:hover {
    background-color: #707070;
    border-color: #707070 !important;
    color: #fff;
  }

  button.ScheduleBtn {
    font-size: 16px;
    min-height: 54px;
  }

  h3.Membership-Prices {
    font-size: 20px;
  }

  .blacktitle {
    font-size: 32px;
  }

  .blackStandard-text {
    font-size: 20px;
    color: #11182F;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .Orangetitle {
    font-size: 36px;
    padding-top: 20px;
  }

  .GolfMemberShip {
    padding: 25px;
  }

  .container {
    padding-left: 0;
    padding-right: 0;
  }

  button.golfMemberBtn {
    background-color: #1A1A1A;
    border-color: #1A1A1A !important;
    border-radius: 50px;
    height: 54px;
    line-height: 1;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    margin-top: 25px;
  }

  button.golfMemberBtn:hover {
    background-color: #D80E1F;
    border-color: #D80E1F !important;
    color: #fff;
  }

  .golfParkText-width {
    width: 100%;
    text-align: center;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .borderMemberShip {
    margin-bottom: 20px;
  }

  ul.MemberBullet-Points {
    padding-left: 30px;
    font-size: 20px;
    padding-bottom: 30px;
  }

  .memberEnquiry {
    bottom: 0;
  }
}

@media only screen and (max-width: 500px) {
  ul.MemberBullet-Points {
    padding-left: 30px;
    font-size: 18px;
    padding-bottom: 30px;
  }

  .borderMemberShip {
    height: auto !important;
    margin-bottom: 20px;
  }

  .memberEnquiry {
    position: static;
    width: 100%;
    padding: 0;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .memberEnquiry > a,
  .memberEnquiry > button {
    width: 100%;
  }

  .memberEnquiry button.MemberBtn,
  .memberEnquiry button.ScheduleBtn {
    width: 100%;
    white-space: normal;
  }
}
</style>
